import { NavLink } from "react-router-dom";
import classes from "./Header.module.css";

const Header = () => {
  const payload = JSON.parse(localStorage.getItem("formioUser"));
  const role = payload?.data?.role;
  console.log("USER ROLE:", role);

  // Base nav items
  const navItems = [
    { topLabel: "Dashboard", label: "My Activity", href: "/activity" },
    { topLabel: "Usage", label: "Manage Documents", href: "/manage-docs" },
    { topLabel: "Maintenance", label: "Maintain Documents", href: "/maintenance" },
    { topLabel: "Disposal", label: "Documents Disposal", href: "/disposal", restricted: true },
    { topLabel: "Notifications", label: "3 Notifications", href: "/notifications" },
    { topLabel: "My account", label: "Creator Mode", href: "/creator-mode" },
  ];

  // Filter nav items based on role
  const filteredNav = navItems.filter((item) => {
    // DisposalManager: only show Disposal + My Account
    if (role === "disposalManager") {
      return item.topLabel === "Disposal" || item.topLabel === "My account";
    }

    // Non-disposal roles: hide Disposal unless allowed
    if (item.topLabel === "Disposal" && role !== "recordsManager" && role !== "disposalManager") {
      return false;
    }

    return true;
  });

  return (
    <div className={classes.wrapper}>
      <div className="d-flex justify-content-between align-items-center">
        <a className="navbar-brand fw-bold" href="/">
          <img src="/EDRMS-logo.svg" alt="logo" className={classes.logo} />
        </a>

        <div className="d-flex align-items-center gap-4">
          {filteredNav.map((item, idx) => (
            <NavLink
              key={idx}
              to={item.href}
              className={({ isActive }) =>
                `d-flex flex-column gap-1 ${classes.navItem} ${
                  isActive ? classes.active : ""
                }`
              }
            >
              {item.topLabel}
              <div className={classes.labelText}>{item.label}</div>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Header;